import { connect } from 'react-redux'
import { changePage } from '../../actions/Paging'
import Paging from '../presentation/Paging'

const mapStateToProps = (state, ownProps) => {
  const o = {
    currentPageNo: state.documents.currentPageNo,
    pageCount: state.documents.pageCount,
    strings: state.i18.strings
  }
  console.log("PageCount:" + o.pageCount);
  return o;
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changePage: (event, index) => {
      event.preventDefault();
      dispatch(changePage(index))
    }
  }
}

const PagingView = connect(mapStateToProps, mapDispatchToProps)(Paging)

export default PagingView;